import * as alertUserRoutines from './routines';
import produce from 'immer';

const initialState = {
    eventImage: null,
    fetched: false,
    loading: false,
    name: null,
    onboardingSaving: false,
    profileImage: null,
    profileImageThumbnail: null,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case alertUserRoutines.clearAlertUserData.TRIGGER:
            return initialState;

        case alertUserRoutines.fetchAlertUser.SUCCESS:
            return { ...state, ...action.payload, fetched: true };
        case alertUserRoutines.fetchAlertUser.FAILURE:
            return { ...state, fetched: true };

        case alertUserRoutines.setInitialSettings.TRIGGER:
            return produce(state, draft => {
                draft.onboardingSaving = 1;
            });
        case alertUserRoutines.removeAlertUserAvatar.SUCCESS:
            return produce(state, draft => {
                draft.profileImage = null;
                draft.profileImageThumbnail = null;
            });
        case alertUserRoutines.saveAlertUserName.SUCCESS:
            return produce(state, draft => {
                draft.onboardingSaving = 25;
                draft.name = action.payload;
            });

        case alertUserRoutines.saveAlertUserImage.TRIGGER:
            return produce(state, draft => {
                draft.loading = true;
            });

        case alertUserRoutines.saveAlertUserImage.SUCCESS:
            return produce(state, draft => {
                draft.onboardingSaving = 50;
                draft.loading = false; //Pertinant for profile display
                draft.profileImage = action.payload.downloadablePath;
                draft.profileImageThumbnail = action.payload.downloadablePath120;
            });

        case alertUserRoutines.setInitialSettings.SUCCESS:
            return produce(state, draft => {
                draft.onboardingSaving = 100;
            });
        default:
            return state;
    }
}
